import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useResolution886ReportFile } from '@/context/Resolution886ReportFiles';
import type { FormData } from '@/context/Resolution886ReportFiles/types';
import * as S from './styles';

const { useWatch, useFormInstance } = Form;

export function SelectAll(): JSX.Element {
	const form = useFormInstance();
	const { onSetDeselectedFiles, onSetSelectAll } = useResolution886ReportFile();
	const fieldName: keyof FormData = 'select_all_files';
	const selectAllFiles = useWatch(fieldName);

	const text = selectAllFiles ? I18n.get('Deselect all') : I18n.get('Select all');

	function handleOnClick(e: React.MouseEvent<HTMLInputElement>): void {
		const value = e.currentTarget.checked;
		form.setFieldValue('file_list_id', undefined);
		onSetDeselectedFiles(new Set());
		onSetSelectAll(value);
	}

	return (
		<Form.Item name={fieldName} valuePropName="checked" noStyle>
			<S.CheckboxText onClick={handleOnClick}>{text}</S.CheckboxText>
		</Form.Item>
	);
}
